module.exports = __webpack_public_path__ + "static/pillBannerMobile-288b5333bb291220d4e72e3671ab0ee6.png";